// components/FaceDetect.js
import React, { useRef, useState, useCallback, useEffect } from "react";
import Webcam from "react-webcam";
import AWS from "aws-sdk";
import { detectPatientByFace } from "../../../api/apiHandler";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import * as bodyPix from "@tensorflow-models/body-pix";
import "@tensorflow/tfjs";
import { Button } from "react-bootstrap";

const videoConstraints = {
  width: 400,
  height: 300,
  facingMode: "user",
};

const FaceDetect = ({
  handleSave,
  setPatientName,
  setShowIsNameModal,
  setContinueByFace,
}) => {
  const webcamRef = useRef(null);

  const capture = () => {
    const screenshot = webcamRef.current?.getScreenshot();
    if (!screenshot) {
      alert("Unable to capture image. Try again.");
      return;
    }
    convertToBuffer(screenshot);
  };

  const rekognition = new AWS.Rekognition({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: process.env.REACT_APP_AWS_S3_REGION,
  });

  const searchFaceByImage = async (imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      FaceMatchThreshold: 90,
      Image: { Bytes: imageBuffer },
      MaxFaces: 1,
    };

    try {
      const result = await rekognition.searchFacesByImage(params).promise();
      console.log(result, "dedecteded");

      if (result.FaceMatches && result.FaceMatches.length > 0) {
        return result.FaceMatches[0].Face;
      } else {
        Swal.fire({
          icon: "info",
          title: "face is not matching",
          toast: true,
          showConfirmButton: false,
          timer: 4000,
        });
      }

      return null;
    } catch (err) {
      console.error("Face detection failed:", err);
      alert("No face detected or something went wrong.");
      return null;
    }
  };

  let dedectFace = async (result) => {
    try {
      let response = await detectPatientByFace({
        awsFaceId: result.FaceId,
      });
      if (response) {
        response = JSON?.parse(response);
      }
      if (response.message === "Patient Not Found") {
        Swal.fire({
          icon: "error",
          title: "No face match found",
          text: response.message || "Something went wrong.",
        });
        console.log(response, "❌ No face match found.");
      } else {
        setPatientName(response.data);
        setShowIsNameModal(false);
        await handleSave(response.data);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No face match found",
        text: error.message || "Something went wrong.",
      });
    }
  };
  const convertToBuffer = async (image) => {
    const buffer = base64ToBuffer(image);
    const result = await searchFaceByImage(buffer);

    if (result?.FaceId) {
      console.log("✅ Face matched:", result);
      dedectFace(result);
    } else {
      console.log(result, "❌ No face match found.");
      alert("No face match found. This face is not enrolled.");
    }
  };

  function base64ToBuffer(base64String) {
    const base64Data = base64String?.split(";base64,")?.pop();
    return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  }

  return (
    <div className="container p-4">
      <h2 className="mb-3">Face Detection</h2>
      <Webcam
        audio={false}
        height={200}
        width={300}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        className="rounded w-100"
      />

      <div className="mt-4 d-flex align-items-center justify-content-between">
        <button
          className="btn btn-primary px-4 py-2 font_14 rounded"
          onClick={capture}
        >
          🔍 Detect Face
        </button>
        <p
          className="mb-0 text-primary text-decoration-underline font_12 cursor-pointer"
          onClick={() => setContinueByFace(false)}
          style={{ cursor: "pointer" }}
        >
          Or Proceed with email or name
        </p>
      </div>
    </div>
  );
};

export default FaceDetect;
